module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0744c_logo_200x200.f47e0492.png";